const SET_SUBSCRIPTION_INFO = (state, payload) => {
    state.subscription_info = {};
    state.subscription_info = payload;
}

const CLEAR_SUBSCRIPTION_INFO = (state) => {
    state.subscription_info = {};
}

const SET_SUBSCRIPTION_DETAIL = (state, payload) => {
    state.subscription_detail = {};
    state.subscription_detail = payload;
}

const CLEAR_SUBSCRIPTION_DETAIL = (state) => {
    state.subscription_detail = {};
}

const SET_SUBSCRIPTION_RECORDS = (state, payload) => {
    state.subscription_records = [];
    state.subscription_records = payload;
}

const CLEAR_SUBSCRIPTION_RECORDS = (state) => {
    state.subscription_records = [];
}

const CLEAR_STATES = (state) => {
    state.subscription_info = {};
    state.subscription_detail = {};
    state.subscription_records = [];
}

export {
    SET_SUBSCRIPTION_INFO,
    CLEAR_SUBSCRIPTION_INFO,
    SET_SUBSCRIPTION_DETAIL,
    CLEAR_SUBSCRIPTION_DETAIL,
    SET_SUBSCRIPTION_RECORDS,
    CLEAR_SUBSCRIPTION_RECORDS,
    CLEAR_STATES
}
